/**
* GameEvent.js
* 
* Created on Oct 2, 2013, 5:05:35 PM
*
* @author Javier Quevedo-Fernandez for Ranj
**/

export default class GameEvent {
    constructor(type) {
        this.type = type;
    }
}

GameEvent.PAUSE_GAME = "GameEvent.PAUSE_GAME";
GameEvent.RESUME_GAME = "GameEvent.RESUME_GAME";
GameEvent.TIME_CHANGE = "GameEvent.TIME_CHANGE";

GameEvent.START = "GameEvent.START";
GameEvent.COMPLETED = "GameEvent.COMPLETED";
GameEvent.TIMEOUT = "GameEvent.TIMEOUT";
GameEvent.EXIT = "GameEvent.EXIT";